import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { usePageTitle } from '../hooks/usePageTitle';
import { DESIGN_TOKENS } from '../theme/designTokens';

const FullPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 200px)', // Adjust based on header/footer height
  textAlign: 'center',
  padding: theme.spacing(4),
  background: 'linear-gradient(135deg, #FEFEFE 0%, #F9FAFB 100%)',
}));

const ContentBox = styled(Box)(({ theme }) => ({
  maxWidth: 600,
  padding: theme.spacing(6),
  background: '#FFFFFF',
  borderRadius: DESIGN_TOKENS.borderRadius.xl,
  border: `1px solid ${theme.palette.divider}`,
}));

const IconContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.main,
  '& svg': {
    fontSize: '6rem',
  },
}));

const NotFound = () => {
  const navigate = useNavigate();
  
  // Set page title for analytics
  usePageTitle('Page Not Found');

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <FullPageContainer>
      <ContentBox>
        <IconContainer>
          <ReportProblemOutlinedIcon />
        </IconContainer>
        <Typography variant="h1" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" component="h2" color="text.primary" sx={{ mb: 2 }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or maybe you just mistyped the URL.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleGoBack}
          size="large"
        >
          Go to Homepage
        </Button>
      </ContentBox>
    </FullPageContainer>
  );
};

export default NotFound; 